import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=db24c5c4"
import script from "./ProfileEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports